class VendorGridRotator {
  constructor(gridElement) {
    this.grid = gridElement;
    this.collectionsData = this.#loadCollections();
    this.currentIndices = Array.from({ length: 9 }, (_, i) => i);
    this.rotationInterval = parseInt(this.grid.dataset.rotationInterval, 10) || 3000;
    this.hoveredSlots = new Set();

    this.#setupHoverListeners();

    if (this.collectionsData.length > 9) {
      this.#startRotation();
    }
  }

  #setupHoverListeners() {
    const items = this.grid.querySelectorAll('.vendor-grid__item');
    items.forEach((item, index) => {
      item.addEventListener('mouseenter', () => {
        this.hoveredSlots.add(index);
      });

      item.addEventListener('mouseleave', () => {
        this.hoveredSlots.delete(index);
      });
    });
  }

  #loadCollections() {
    const root = this.grid.closest('.vendor-grid-root');
    const script = root?.querySelector('[data-vendor-collections]');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch {
      return [];
    }
  }

  #startRotation() {
    setInterval(() => {
      this.#rotateRandomSlot();
    }, this.rotationInterval);
  }

  #rotateRandomSlot() {
    const slotIndex = Math.floor(Math.random() * 9);
    const content = this.grid.querySelector(`[data-slot="${slotIndex}"]`);

    if (!content) return;

    if (this.hoveredSlots.has(slotIndex)) return;

    const existingOverlay = content.querySelector('.vendor-grid__logo-overlay');
    if (existingOverlay) return;

    const currentCollectionIndex = this.currentIndices[slotIndex];
    let newCollectionIndex;
    let attempts = 0;
    const maxAttempts = 100;

    do {
      newCollectionIndex = Math.floor(Math.random() * this.collectionsData.length);
      attempts++;

      if (attempts >= maxAttempts) {
        for (let i = 0; i < this.collectionsData.length; i++) {
          if (!this.currentIndices.includes(i) && i !== currentCollectionIndex) {
            newCollectionIndex = i;
            break;
          }
        }

        if (newCollectionIndex === currentCollectionIndex || this.currentIndices.includes(newCollectionIndex)) {
          for (let i = 0; i < this.collectionsData.length; i++) {
            if (i !== currentCollectionIndex) {
              newCollectionIndex = i;
              break;
            }
          }
        }

        break;
      }
    } while (this.currentIndices.includes(newCollectionIndex) || newCollectionIndex === currentCollectionIndex);

    this.currentIndices[slotIndex] = newCollectionIndex;
    const collection = this.collectionsData[newCollectionIndex];

    const currentLink = content.querySelector('a');
    const currentImg = content.querySelector('.vendor-grid__logo');

    if (!currentLink || !currentImg) return;

    const overlay = document.createElement('div');
    overlay.className =
      'vendor-grid__logo-overlay absolute inset-0 z-10 flex items-center justify-center pointer-events-none [&_img]:h-auto [&_img]:max-w-full group-hover:[animation-play-state:paused]';

    const root = this.grid.closest('.vendor-grid-root');
    const resolvedBg = root ? getComputedStyle(root).backgroundColor : '';
    if (resolvedBg && resolvedBg !== 'rgba(0, 0, 0, 0)' && resolvedBg !== 'transparent') {
      overlay.style.backgroundColor = resolvedBg;
    } else {
      overlay.classList.add('bg-background');
    }

    const overlayImg = currentImg.cloneNode(true);
    overlay.appendChild(overlayImg);

    currentLink.appendChild(overlay);

    currentLink.href = collection.url;
    currentImg.src = collection.logo;
    currentImg.alt = collection.title;
    currentImg.setAttribute('aria-label', collection.title);

    currentImg.removeAttribute('srcset');
    currentImg.removeAttribute('width');
    currentImg.removeAttribute('height');

    requestAnimationFrame(() => {
      overlay.classList.add('animate-vendor-grid-dissolve');

      setTimeout(() => {
        overlay.remove();
      }, 1000);
    });
  }
}

function initVendorGrid() {
  const grids = document.querySelectorAll('.vendor-grid');
  for (const grid of grids) {
    new VendorGridRotator(grid);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVendorGrid);
} else {
  initVendorGrid();
}
